import React, { useEffect, useState } from 'react';
import './EmailConfirmed.css';

type PageState = 'loading' | 'success' | 'error';

const EmailConfirmed: React.FC = () => {
  const [state, setState] = useState<PageState>('loading');
  const [errorDescription, setErrorDescription] = useState<string>('');

  useEffect(() => {
    const hash = window.location.hash.substring(1); // strip leading '#'
    const params = new URLSearchParams(hash);

    const error = params.get('error');
    const errorDesc = params.get('error_description');
    const type = params.get('type');
    const accessToken = params.get('access_token');

    if (error) {
      setErrorDescription(
        errorDesc
          ? decodeURIComponent(errorDesc.replace(/\+/g, ' '))
          : 'The confirmation link is invalid or has expired.'
      );
      setState('error');
    } else if ((type === 'signup' || type === 'email') && accessToken) {
      setState('success');
    } else {
      // No recognisable params — treat as a plain landing visit (success)
      setState('success');
    }
  }, []);

  return (
    <div className="ec-page">
      <div className="ec-header">
        <div className="container">
          <div className="ec-logo">LITSCAN</div>
        </div>
      </div>

      <div className="ec-body">
        <div className="container">
          <div className="ec-card">
            {state === 'loading' && (
              <div className="ec-loading">
                <div className="ec-spinner" />
                <p>Verifying your email…</p>
              </div>
            )}

            {state === 'success' && (
              <>
                <div className="ec-icon ec-icon--success">✓</div>
                <h1 className="ec-title">Email Confirmed!</h1>
                <p className="ec-subtitle">
                  Your account is now active. Open the LITSCAN app and sign in
                  to start exploring what's lit tonight.
                </p>
                <div className="ec-divider" />
                <p className="ec-hint">
                  Already have the app open? Head back and tap <strong>Log In</strong>.
                </p>
              </>
            )}

            {state === 'error' && (
              <>
                <div className="ec-icon ec-icon--error">✗</div>
                <h1 className="ec-title">Confirmation Failed</h1>
                <p className="ec-subtitle">{errorDescription}</p>
                <div className="ec-divider" />
                <p className="ec-hint">
                  Please try signing up again in the app, or contact us at{' '}
                  <a href="mailto:support@litscan.app">support@litscan.app</a>.
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      {/*<div className="ec-footer">*/}
      {/*  <div className="container">*/}
      {/*    <a href="/" className="ec-back">← Back to Home</a>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default EmailConfirmed;

